import { useMemo } from 'react';

import type { AppListItem } from '@app/api/apps';

import useQueryParam from './useQueryParam';

const usePreSelectedApp = (contentIntegrationApps: AppListItem[]) => {
    const slugParam = useQueryParam('appSlug');

    const preSelectedApp = useMemo(
        () => contentIntegrationApps.filter(({ slug }) => slug === slugParam),
        [contentIntegrationApps, slugParam],
    );

    return {
        preSelectedAppLabel: preSelectedApp.length && preSelectedApp[0].isAvailable ? preSelectedApp[0].title : '',
    };
};

export default usePreSelectedApp;
